import * as React from 'react';
import { TextField } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';
import { PasswordStrengthIndicator } from './PasswordStrengthIndicator/PasswordStrengthIndicator';
import * as is from 'is_js';
import styled from 'styled-components';
import { LG } from '@origin-digital/helper';

interface PasswordComponentState {
  isHidden: boolean;
  type: string;
  blurred: boolean;
}

interface PasswordComponentProps {
  onPasswordChanged: (event) => void;
  showPasswordErrorMessage: boolean;
  password: string;
}

class PasswordComponent extends React.PureComponent<
  PasswordComponentProps,
  PasswordComponentState
> {
  public state = {
    isHidden: true,
    type: 'password',
    blurred: false,
  };

  public render() {
    const hasError = this.props.showPasswordErrorMessage;
    return (
      <PasswordWidgetContainer>
        <Box position="relative">
          <ShowPasswordButton
            data-id="password-toggle"
            onClick={this.onToggleClick}
            indentLeft={this.state.blurred && hasError}
          >
            {this.state.type === 'text' ? 'Hide' : 'Show'}
          </ShowPasswordButton>
          <TextField
            label="Password"
            name="password"
            type={this.state.type}
            value={this.props.password}
            onBlur={this.repositionLabel}
            onChange={this.props.onPasswordChanged}
            id="password"
            autoComplete="new-password"
            data-id="password-textfield"
            error={hasError ? 'Password entered is not strong enough' : ''}
            disableIcon={!hasError}
            // this is here to make sure autofill works
            orderHiddenInputLast={true}
          />
        </Box>
        <PasswordStrengthIndicator password={this.props.password} />
      </PasswordWidgetContainer>
    );
  }
  private repositionLabel = (e) => {
    this.setState({ blurred: true });
  };
  private onToggleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      type: this.state.type === 'text' ? 'password' : 'text',
    });
  };
}

export { PasswordComponent };

const PasswordWidgetContainer = styled.div`
  margin-bottom: 24px;
  ${LG`
    margin-bottom: 32px;
  `}
`;

interface ShowHideToggleProps {
  'data-id': string;
  indentLeft: boolean;
}

const ShowPasswordButton = styled.span<ShowHideToggleProps>`
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 21px;
  z-index: 1;
  visibility: ${() => (is.ie() || is.edge() ? 'hidden' : 'visible')};
  margin-right: ${(props) => (props.indentLeft ? '44px' : '24px')};
`;
